export default __webpack_public_path__ + "926edc7ad9d76fc1be5d4803090dfad3.png";